import {
  ExplanationReservationScene,
  GqlError,
  SendVideoCallStartedNotificationDocument,
  VideoCallStartedNotificationSendTo,
} from 'src/lib/gql-client'
import { graphqlRequest } from 'src/lib/gql-client/request'

import { useMutation, UseMutationOption } from '../../../../hooks/use-mutation'

const sendVideoCallStartedNotification = async ({
  trialPatientUid,
  scene,
  sendTo,
}: {
  trialPatientUid: string
  scene: ExplanationReservationScene
  sendTo: VideoCallStartedNotificationSendTo
}): Promise<void> => {
  try {
    await graphqlRequest(SendVideoCallStartedNotificationDocument, {
      input: {
        trialPatientUid,
        scene,
        sendTo,
      },
    })
  } catch (error) {
    throw error
  }
}

export const useSendVideoCallStartedNotification = (
  option?: UseMutationOption<void, GqlError>,
) => {
  return useMutation(
    ({
      trialPatientUid,
      scene,
      sendTo,
    }: {
      trialPatientUid: string
      scene: ExplanationReservationScene
      sendTo: VideoCallStartedNotificationSendTo
    }) =>
      sendVideoCallStartedNotification({
        trialPatientUid,
        scene,
        sendTo,
      }),
    option,
  )
}
